export const SELECT_OPTION_ID = (id: string): string => `select-option-${id}`
export const SELECT_DROPDOWN_WRAPPER_ID = 'select-dropdown-wrapper'
